import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessfully = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M38.8558 5.46842C38.2674 4.87897 37.3126 4.87795 36.7242 5.46592L18.6388 23.5036L12.1137 16.4166C11.5498 15.8046 10.5965 15.7649 9.9835 16.3287C9.37092 16.8925 9.3317 17.8462 9.89553 18.4588L17.4835 26.6995C17.7614 27.0015 18.1503 27.1769 18.5604 27.1854C18.5714 27.1859 18.582 27.1859 18.5926 27.1859C18.9911 27.1859 19.3744 27.0276 19.6569 26.7462L38.8529 7.60053C39.4428 7.01264 39.4438 6.05787 38.8558 5.46842Z",
		fill: "#1CB954"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M38.4924 18.4924C37.6598 18.4924 36.9849 19.1673 36.9849 20C36.9849 29.3659 29.3659 36.9849 20 36.9849C10.6347 36.9849 3.01508 29.3659 3.01508 20C3.01508 10.6347 10.6347 3.01508 20 3.01508C20.8327 3.01508 21.5076 2.34023 21.5076 1.50758C21.5076 0.674844 20.8327 0 20 0C8.97187 0 0 8.97187 0 20C0 31.0277 8.97187 40 20 40C31.0277 40 40 31.0277 40 20C40 19.1673 39.3252 18.4924 38.4924 18.4924Z",
		fill: "#1CB954"
	})]
});
export default SvgSuccessfully;
